module.exports = __webpack_public_path__ + "img/companyNameImg_c.7cb59114.png";